<script lang="ts">
  import clsx from 'clsx';
  import BaseHeading from '../BaseHeading/BaseHeading.svelte';
  import type { HeadingXXSmallProps } from './types';
  let { class: className, size = 'xsmall', ...props }: HeadingXXSmallProps = $props();
</script>

<BaseHeading class={clsx(className)} {size} level={5} {...props} />
